import React from 'react';
import EmptyCheckBoxIcon from 'images/icons/uncheckedCheckBox.svg';
import CheckBoxIcon from 'images/icons/checkedCheckBox.svg';
import MuCheckbox from '@material-ui/core/Checkbox';
import IndeterminateCheckBox from 'images/icons/IndeterminateCheckBox.svg';

const disabledStyle = {
  opacity: 0.7,
  filter: 'grayscale(100%)'
};

const Checkbox = props => (
  <MuCheckbox
    icon={<img src={EmptyCheckBoxIcon} alt='unchecked' />}
    checkedIcon={<img src={props.checkboxIcon || CheckBoxIcon} alt='checked' />}
    indeterminateIcon={
      <img src={IndeterminateCheckBox} alt='indeterminateCheck' />
    }
    style={props.disabled ? disabledStyle : {}}
    {...props}
  />
);

export default Checkbox;
